import React from "react";
import { SharedMarketPlaceTraderAnalyses } from "@app/shared";

const MarketPlaceTraderAnalysisList: React.FC = () => {
  return <SharedMarketPlaceTraderAnalyses />;
};

export default MarketPlaceTraderAnalysisList;
